import React from "react";
import he_IL from "antd/locale/he_IL";
import dayjs from "dayjs";
import "dayjs/locale/he";

dayjs.locale(
  "he",
  {
    months: [
      "ינואר",
      "פברואר",
      "מרץ",
      "אפריל",
      "מאי",
      "יוני",
      "יולי",
      "אוגוסט",
      "ספטמבר",
      "אוקטובר",
      "נובמבר",
      "דצמבר",
    ],
    formats: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [ב]MMMM YYYY",
      LLL: "D [ב]MMMM YYYY HH:mm",
      LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
    },
    monthsShort: [
      "ינו׳",
      "פבר׳",
      "מרץ",
      "אפר׳",
      "מאי",
      "יוני",
      "יולי",
      "אוג׳",
      "ספט׳",
      "אוק׳",
      "נוב׳",
      "דצמ׳",
    ],
    weekdays: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
    weekdaysShort: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
    weekdaysMin: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
    name: "Hebrew",
    ordinal: (number) => {
      const suffixes = ["", "א", "ב", "ג", "ד", "ה", "ו", "ז", "ח", "ט"];
      return number + (suffixes[number % 10] || "");
    },
    week: {
      dow: 0,
      doy: 6,
    },
    weekStart: 0,
    relativeTime: {
      d: "יום",
      dd: "ימים",
      M: "חודש",
      MM: "חודשים",
      y: "שנה",
      yy: "שנים",
      future: (s) => `בעוד ${s}`,
      past: (s) => `לפני ${s}`,
      h: "שעה",
      hh: "שעות",
      m: "דקה",
      mm: "דקות",
      s: "שניות",
    },
  },
  true
);

export const dateHebLocale = {
  ...he_IL.DatePicker,
  lang: {
    ...he_IL.DatePicker.lang,
  },
};

/** UI lives in SearchEngineTabFields; default export kept for compatibility. */
export default function OrganizedTourSearchBar() {
  return null;
}
